// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3ca9c92f","977":"3090817c"}[chunkId] + ".chunk.js";
};